import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  let title

  switch (templateId) {
    case 1:
      title = 'Termo de uso'
      break
    case 2:
      title = 'OS - Operador de Máquinas Pesadas'
      break
    case 3:
      title = 'OS - Motorista de Caminhão Truck'
      break
    case 4:
      title = 'OS - Auxiliar de Serviços Gerais'
      break
    case 5:
      title = 'OS - Operador de Motosserra'
      break
    case 6:
      title = 'Certificado - NR-18'
      break
    case 7:
      title = 'Certificado - NR-35'
      break
    case 8:
      title = 'Certificado - NR-12 - Motosserras'
      break
    case 9:
      title = 'Certificado - NR-12'
      break
    case 10:
      title = 'Certificado - NR-17'
      break
    case 11:
      title = 'Certificado - NR-23'
      break
    default:
      break
  }

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={serviceOrder?.id} templateId={templateId} />}
    />
  )
}

export default PageHeader
